import { LatLng, LatLngBounds } from 'leaflet';
import { useEffect, useMemo } from 'react';
import { AONB_Bounds } from '../../application/config';
import { useMap } from 'react-leaflet';
import { Trail } from '../../models/Trail';
import { getTrailPathLatLngs } from './mapPointUtils';

type MapControllerProps = {
	trails: Trail[];
	isVisible?: boolean;
};

const calcBoundary = (pointList: LatLng[]) => {
	let boundary: LatLngBounds;

	switch (pointList.length) {
		case 0:
			boundary = new LatLngBounds(
				AONB_Bounds.getSouthWest(),
				AONB_Bounds.getNorthEast(),
			);
			break;
		case 1:
			boundary = new LatLngBounds(
				AONB_Bounds.getSouthWest(),
				AONB_Bounds.getNorthEast(),
			);
			boundary.extend(pointList[0]);
			break;
		default:
			boundary = new LatLngBounds(pointList[0], pointList[1]);
			for (let listNdx = 2; listNdx < pointList.length; listNdx++) {
				boundary.extend(pointList[listNdx]);
			}
			break;
	}

	return boundary;
};

export default function TrailsMapController({
	trails,
	isVisible = true,
}: MapControllerProps) {
	const map = useMap();
	const trailPoints = useMemo(
		() => trails.flatMap((trail) => getTrailPathLatLngs(trail)),
		[trails],
	);

	useEffect(() => {
		if (!isVisible) {
			return;
		}

		const fitToTrails = () => {
			try {
				map.invalidateSize();
				const boundary = calcBoundary(trailPoints);
				if (!boundary.isValid()) {
					return;
				}
				map.fitBounds(boundary, {
					padding: [24, 24],
					maxZoom: 15,
				});
			} catch (e) {
				/* ignore fit failures */
			}
		};

		// Ionic modal layout settles after open, so refit once the map has a
		// real container size instead of only the pre-animation dimensions.
		fitToTrails();
		const timeoutId = window.setTimeout(fitToTrails, 150);

		return () => {
			window.clearTimeout(timeoutId);
		};
	}, [isVisible, map, trailPoints]);

	return null;
}
